import { isValidCPF, validateName } from '@/utils/validations'
import { z } from 'zod'

export const minorsTermSchema = z.object({
  guardianName: z.string().refine(
    value => {
      return validateName(value)
    },

    { message: 'Informe um nome correto' },
  ),
  guardianCpf: z.string().refine(
    value => {
      if (value.length < 14) return false
      return isValidCPF(value)
    },

    { message: 'CPF inválido' },
  ),
  minorsTerm: z.boolean().refine(
    value => {
      if (!value) return false
      return value
    },

    { message: 'É necessário aceitar o termo' },
  ),
})
